import { render, staticRenderFns } from "./BikyConfigMyKeybeCatalog.vue?vue&type=template&id=68cdf098&scoped=true&"
import script from "./BikyConfigMyKeybeCatalog.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigMyKeybeCatalog.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigMyKeybeCatalog.vue?vue&type=style&index=0&id=68cdf098&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cdf098",
  null
  
)

export default component.exports